export default __webpack_public_path__ + "1dd3aa50894d9b131e89f7e2b416bde1.png";